import React from 'react';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import SelectFilter from './SelectFilter';

// STYLES
import styles from './sortFilter.module.scss';
import SortButton from './SortButton';

// MAIN COMPONENT
const SortFilter = ({
  options,
  ...props
}) => options.length < 1 ? (
  <SortButton {...props} />
) : (
  <Form.Col>
    <Form.Row>
      {!props.inline &&
        <Form.Label
          label="Sort By"
        />
      }
      <Form.Col>
        <Form.Group className={styles.container}>
          <SelectFilter
            className={styles.select}
            name="sort"
            placeholder="Sort By"
            options={options}
            useNone={false}
            {...props}
          />
          <SortButton
            className={styles.button}
            {...props}
          />
        </Form.Group>
      </Form.Col>
    </Form.Row>
  </Form.Col>
)

// EXPORT
export default SortFilter;
